export const INPUT_CONFIG = {
    COLOR_PICKER: {
        maxLength: 8,
    },
    DATA_INPUT: {
        maxLength: 10,
    },
    SHORT_TEXT: {
        maxLength: 50,
    },
    DESCRIPTION: {
        maxLength: 2000,
    },
    PHONE: {
        maxLength: 16,
    },
    ZIP_CODE: {
        minLength: 3,
        maxLength: 16,
    },
    DURATION: { maxLength: 10 },
    NUMBER: { maxLength: 50 },
    PASSWORD: {
        minLength: 8,
        maxLength: 50,
    },
    UPLOAD: {
        MAX_FILE_SIZE_MB: 1,
        MAX_FILE_SIZE_BYTES: 1 * 1024 * 1024,
        MIN_IMAGE_WIDTH: 100,
        MIN_IMAGE_HEIGHT: 100,
        MAX_IMAGE_WIDTH: 1000,
        MAX_IMAGE_HEIGHT: 1000,
        IMAGE_LOAD_TIMEOUT_MS: 5000,
    },
};
